import { useMemo } from 'react';
import { diffWords } from 'diff';
import cn from 'classnames';

// Copied from TextCollectionDiff but with styles removed
export function TextDiff({
  originalText,
  newText,
  className = '',
}: {
  originalText: string;
  newText: string;
  className?: string;
}) {
  const diffTexts = useMemo(() => {
    if (originalText && newText) {
      const changes = diffWords(originalText, newText);
      // inspired by react-diff
      const diffTexts = changes.map((part, partI) => {
        return (
          <span
            key={`diff_${partI}`}
            className={cn('prose text-xs whitespace-pre-wrap', {
              'text-neutral-700 line-through decoration-neutral-400': part.removed,
              'text-success-800 bg-success-50': part.added,
              'text-neutral-900': !part.added && !part.removed,
              className,
            })}
            style={{ fontFamily: 'monospace' }}
          >
            {part.value}
          </span>
        );
      });
      return diffTexts;
    }
  }, [originalText, newText, className]);

  return <div className="whitespace-pre-wrap">{diffTexts}</div>;
}
